const { debounce } = window.BAO.Utils
class QuickSearch extends window.BAO.CustomElement() {
  connectedCallback() {
    super.connectedCallback()
    this.loadQuickSearch()
  }

  setupListeners() {
    super.setupListeners()

    this.loadQuickSearch = this.loadQuickSearch.bind(this)
    this.onFocus = this.onFocus.bind(this)
    this.handleOpen = this.handleOpen.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleClear = this.handleClear.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.handleSearch = debounce(this.handleSearch.bind(this), 300)
    this.handleOutsideClick = this.handleOutsideClick.bind(this)

    this.externalEls?.input?.elements.forEach((externalInputEl) => {
      this.listeners.add(externalInputEl, 'focus', this.onFocus)
    })

    this.externalEls?.input?.elements.forEach((externalInputEl) => {
      this.listeners.add(externalInputEl, 'keyup', this.handleSearch)
    })

    this.externalEls?.input?.elements.forEach((externalInputEl) => {
      const wrapper = externalInputEl.closest('[data-quick-search-external-el="input-wrap"]')
      if (!wrapper) return

      const clearBtn = wrapper.querySelector('[data-quick-search-external-el="clear"]')
      if (clearBtn) {
        this.listeners.add(clearBtn, 'click', this.handleClear)
      }

      this.listeners.add(externalInputEl, 'input', this.handleInput)
    })

    this.listeners.add(this?.els?.backdrop?.element, 'click', this.handleClose)
    document.addEventListener('click', this.handleOutsideClick)

  }

  onFocus(event) {
    const searchTerm = event.target.value
    if (searchTerm.length === 0) this.displayDefaultLayout()
    this.handleOpen()
  }

  handleOpen() {
    this.setAttribute('aria-hidden', 'false')
    document.body.classList.add('util-SiteOverflowed')

    /* Forces Keen slider to recalculate available width properly. */
    window.dispatchEvent(new Event('resize'));
  }

  handleClose() {
    this.setAttribute('aria-hidden', 'true')
    document.body.classList.remove('util-SiteOverflowed')
  }

  handleOutsideClick(event) {
    const isOpen = this.getAttribute('aria-hidden') === 'false'
    if (!isOpen) return

    const clickedInside =
      this.contains(event.target) ||
      event.target.closest('[data-quick-search-external-el="input-wrap"]')

    if (!clickedInside) {
      this.handleClose()
    }
  }

  handleSearch(event) {
    const searchTerm = event.target.value
    if (searchTerm.length === 0) {
      this.displayDefaultLayout()
    } else {
      this.loadResults(searchTerm)
    }
  }

  handleInput(event) {
    const inputEl = event.target
    const wrapper = inputEl.closest('[data-quick-search-external-el="input-wrap"]')
    if (!wrapper) return

    if (inputEl.value.length > 0) {
      wrapper.classList.add('hd-QuickSearch_InputWrap-has-value')
      this.handleOpen()
    } else {
      wrapper.classList.remove('hd-QuickSearch_InputWrap-has-value')
      this.handleClose()
    }
  }

  handleClear(event) {
    const clearBtn = event.currentTarget
    const wrapper = clearBtn.closest('[data-quick-search-external-el="input-wrap"]')
    if (!wrapper) return

    const inputEl = wrapper.querySelector('input')
    if (!inputEl) return

    inputEl.value = ''
    wrapper.classList.remove('hd-QuickSearch_InputWrap-has-value')
    this.displayDefaultLayout()
    inputEl.blur()
    this.handleClose()
  }

  loadQuickSearch() {
    return window.BAO.sectionRenderer
      .fetchSingle('quick-search')
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
        const DOMSection = newDOM.querySelector('section')

        if (DOMSection) {
          this.els.container.element.innerHTML = `${DOMSection.outerHTML}`
        }
      })
      .catch((error) => {
        return null
      })
  }

  displayDefaultLayout() {
    const {
      'layout-default': layoutDefault,
      'layout-no-results': layoutNoResults,
      'layout-results': layoutResults
    } = this.els || {};

    layoutDefault?.element?.setAttribute('aria-hidden', 'false')
    layoutNoResults?.element?.setAttribute('aria-hidden', 'true')
    layoutResults?.element?.setAttribute('aria-hidden', 'true')
    window.dispatchEvent(new Event('resize'));
  }

  async loadResults(searchTerm) {
    try {
      const response = await fetch(
        `/search/suggest?q=${searchTerm}&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,variants.sku,body&section_id=quick-search`
      )
      const content = await response.text()

      const html = document.createElement('div')
      html.innerHTML = content

      const newSection = html.querySelector('section')
      const currentSection = this.els.container.element.querySelector('section')

      if (newSection && currentSection) {
        currentSection.replaceWith(newSection)
      }

    } catch (e) {
      console.error(e)
    }
  }
}

if (!customElements.get('quick-search')) {
  customElements.define('quick-search', QuickSearch)
}
